import React, { PureComponent } from 'react'
import { Button, Modal, Form, Row } from 'react-bootstrap'
import { reduxForm } from 'redux-form'
import SaleRequestFields from '../../../components/dossiers/common/saleRequestFields/SaleRequestFields'
import { handleKeyDown } from '../../../util/utils'

class SaleRequestModal extends PureComponent {
  constructor () {
    super()
    this.state = {
      purchaseType: null
    }
  }

  submit (values) {
    new Promise((resolve, reject) => {
      this.props.actions.saveOrder({ ...this.props.order, ...values }, this.props.dossierId, true, this.props.dossierType, resolve)
    }).then(() => {
      this.props.actions.closeSaleRequestModal()
    })
  }

  render () {
    const {
      t, handleSubmit, readOnlyFields, showSaleRequestModal,
      actions: { closeSaleRequestModal }, combos: { entityTransferCombo, purchaseTypeVnCombo }
    } = this.props
    const tKey = 'DOSSIER_COMPONENTS.SALE_REQUEST_MODAL.'
    return (
      <Modal id='SaleRequestModal' className="_nf" show={showSaleRequestModal} onHide={closeSaleRequestModal}>
        <Form autoComplete="off" onSubmit={handleSubmit(this.submit.bind(this))} onKeyDown={(e) => handleKeyDown(e)}>
          <Modal.Header closeButton>
            <Modal.Title>{t(`${tKey}TITLE`)}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Row className='fieldsContainer'>
              <SaleRequestFields
                t={t}
                readOnlyFields={readOnlyFields}
                purchaseTypeVnCombo={purchaseTypeVnCombo}
                entityTransferCombo={entityTransferCombo}
                validateRequired={true}
              />
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <div className='flexInLine al-C'>
              <Button id="btn_save" className="_Btn new" type="submit">{t('GLOBAL.BUTTONS.SAVE')}</Button>
            </div>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }
}

export default reduxForm({
  form: 'saleRequestModal',
  validate: (values, { t }) => {
    const errors = {}

    return errors
  }
})(SaleRequestModal)
